import { PersistedClient, Persister } from '@tanstack/react-query-persist-client';
import localforage from 'localforage';

/**
 * Creates an Indexed DB persister
 * @see https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */
export function createIDBPersister(idbValidKey: string = 'reactQuery') {
  return {
    persistClient: async (client: PersistedClient) => {
      await localforage.setItem(idbValidKey, client);
    },
    restoreClient: async () => {
      return await localforage.getItem(idbValidKey);
    },
    removeClient: async () => {
      await localforage.removeItem(idbValidKey);
    },
  } as Persister;
}

export const queriesToCache = [
  'useGetYieldByField',
  'useGetYieldByVariety',
  'useGetYieldBySoilType',
  'getSoilGeometries',
  'getValidationBlocksGeometries',
  'get-varieties-geometries-data',
  'getManagementZones',
  'getHeatMap',
  'fields_with_operations',
  'useGetOperation',
  'useGetOperationImages',
  'field-operations',
  'organizations',
  'crop-stages-catalog',
];
